<template>
    <v-layout justify-center>
        <v-responsive max-width="1280" width="100%" height="100%" class="mx-n3 px-3">
            <list-heading title="설비 목록">
                <template #add-button>
                    <rental-subject-view>
                        <template #activator="{ attrs, on }">
                            <v-btn text icon tile color="primary" title="설비 생성" v-bind="attrs" v-on="on"> <v-icon>mdi-plus</v-icon> </v-btn>
                        </template>
                    </rental-subject-view>
                </template>
                <template #buttons>
                    <subject-select-shows v-bind="{ loading }" dense flat solo hide-details class="v-sheet--outlined" style="width: 180px" />
                </template>
            </list-heading>

            <v-card outlined style="overflow: hidden">
                <v-data-table v-bind="{ items, headers, loading }" disable-sort disable-pagination hide-default-footer :items-per-page="-1">
                    <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
                    <template #[`item.thumb`]="{ value }">
                        <v-img v-bind="value" :aspect-ratio="1 / 1" width="48" class="rounded-lg my-1 v-sheet--outlined ml-auto" />
                    </template>
                    <template #[`item.shows`]="{ item, value }">
                        <v-row justify="center" align="center">
                            <v-col cols="auto" class="pa-0">
                                <v-switch v-model="item.shows" readonly inset @click="save({ _id: item._id, shows: !value })" class="ma-0 ml-1 mr-n3 pa-0" hide-details />
                            </v-col>
                        </v-row>
                    </template>
                    <template #[`item.isRentDisabled`]="{ item, value }">
                        <v-row justify="center" align="center">
                            <v-col cols="auto" class="pa-0">
                                <v-switch v-model="item.isRentDisabled" readonly inset @click="save({ _id: item._id, isRentDisabled: !value })" class="ma-0 ml-1 mr-n3 pa-0" hide-details />
                            </v-col>
                        </v-row>
                    </template>
                    <template #[`item.actions`]="{ item }">
                        <rental-subject-view :value="item" @input="(item) => update(item)">
                            <template #activator="{ attrs, on }">
                                <v-icon small v-bind="attrs" v-on="on"> mdi-pencil </v-icon>
                            </template>
                        </rental-subject-view>
                    </template>
                </v-data-table>
            </v-card>
            <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="mt-2" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { RENTAL_SUBJECT_TYPES } from "@/assets/variables";

import ListSearch from "@/components/console/dumb/list-search.vue";
import ListHeading from "@/components/console/dumb/list-heading.vue";
import RentalSubjectView from "@/components/console/rental/rental-subject-view.vue";
import SubjectSelectShows from "@/components/console/rental/subject-select-shows.vue";

const headers = [
    { align: "center", width: +80, text: "유형", value: "type", formatter: (key) => RENTAL_SUBJECT_TYPES[key]?.text },
    { align: "start", width: 240, text: "장소", value: "location" },
    { align: "start", width: 240, text: "설비명", value: "name", divider: false },
    { align: "right", width: +90, text: "", value: "thumb" },
    { align: "center", width: +80, text: "비용유형", value: "isFree", formatter: (value) => (value ? "무료" : "유료") },
    { align: "center", width: 120, text: "비용표기", value: "charge", formatter: (value) => value || "-" },
    { align: "center", width: +90, text: "사용자\n노출", value: "shows", class: "white-space-pre-line", divider: false },
    { align: "center", width: +90, text: "예약하기\n비활성화", value: "isRentDisabled", class: "white-space-pre-line" },
    { align: "center", width: +50, text: "", value: "actions" },
].map((item, index, array) => ({ ...item, formatter: item?.formatter || ((value) => value || "-"), divider: item.divider ?? index != array.length - 1 }));

export default {
    components: {
        ListSearch,
        ListHeading,
        RentalSubjectView,
        SubjectSelectShows,
    },
    data: () => ({
        subjects: [],
        summary: { totalCount: 0 },

        limit: 10,
        loading: false,

        headers,
    }),
    computed: {
        items() {
            return this.subjects;
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;
            return { ...query };
        },
    },

    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },

    methods: {
        async init() {
            try {
                this.search();
            } catch (error) {
                console.error(error);
            }
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { skip, limit, params } = this;

                var { summary, subjects } = await api.console.rental.subjects.gets({
                    headers: { skip, limit },
                    params,
                });

                console.log(subjects.reduce((text, { _id, name }) => text + `${name} / ${_id} \r\n`, ""));

                this.subjects = subjects;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },

        async update(item) {
            const index = this.subjects.findIndex(({ _id }) => _id == item._id);
            this.subjects.splice(index, 1, item);
            this.search();
        },

        async save(item) {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { subject } = await api.console.rental.subjects.put(item);
                this.update(subject);
                this.loading = false;
                this.search();
            } finally {
                if (this.loading) this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .white-space-pre-line {
        white-space: pre-line;
    }
}
</style>